(function () {
  // Solo ejecutar en desktop
  if (window.innerWidth < 1024) return;

  const wrapper = document.getElementById('video-flotante-wrapper');
  const closeBtn = document.getElementById('video-flotante-close');

  if (!wrapper || !closeBtn) return;

  // Cerrar al hacer clic en ✕
  closeBtn.addEventListener('click', function () {
    wrapper.classList.add('oculto');
  });

  // Ocultar cuando el carrusel de medias es visible, mostrar al hacer scroll
  const mediaGallery = document.querySelector(
    '.product__media-wrapper, .product-media-container, [data-product-media-container]'
  );

  if (mediaGallery) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            wrapper.classList.add('oculto');
          } else {
            wrapper.classList.remove('oculto');
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(mediaGallery);
  }
})();
